/// <amd-module name="typeahead/features/SelectInputElement" />
/// <amd-dependency path="jquery" name="$"/>

import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IInputElementFocusByHumanOrScriptHandler}
    from "typeahead/core/presentation/IInputElementFocusByHumanOrScriptHandler";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

const configuration: IStripingConfiguration[] = [
    {
        clients: ["Flights.Search"],
        experiment: {
            id: 15332,
            name: "FSRP_uTA_InputAutoSelect",
            value: 1,
        },
    },
    // An empty striping configuration at the end enables the feature in all contexts that are ignored by all preceding
    // striping configurations.
    {},
];

export class SelectInputElementOnFocus
        implements IExperimentalFeature, IInputElementFocusByHumanOrScriptHandler<void> {
    private static enableAutoSelection($inputElement): void {
        let selectAllText = () => {
            let htmlInputEl: HTMLInputElement = <HTMLInputElement> $($inputElement)[0];
            if (htmlInputEl) {
                htmlInputEl.setSelectionRange(0, 9999);
            }
        };
        setTimeout(() => {
            $($inputElement).one("mouseup", () => {
                selectAllText();
            });
            selectAllText();
        }, 0);
    }

    public getExperiments(): UtaExperiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    public handleInputElementFocusByHumanOrScript($inputElement: JQuery, context: IContext): JQueryPromise<void> {
        ExecutionHelper.shouldExecute(context, configuration)
            .done((shouldExecute) => {
                if (shouldExecute) {
                    SelectInputElementOnFocus.enableAutoSelection($inputElement);
                }
            });
        return ($.Deferred() as JQueryDeferred<undefined>).resolve().promise();
    }
}
